<template lang='pug'>
.footer
  .footer-left
    h4.color--black90 © LINE Taiwan Limited
  .footer-center
    ul.footer-list
      li.footer-item(v-for='(element, idx) in elements' :idx="idx" v-if="identity == 'users' || identity == null")
        a.footer-link(v-if="element.text == '隱私權政策'" :href="element.link" target="_blank") {{ element.text }}
        a.footer-link(v-else :href="$store.state.URLs.base + element.link" target="_blank") {{ element.text }}
  PopupContentContactForm(v-if="popupContactForm" @closePopup="closeContactForm" @isSuccess="isSuccess" @isError="isError")
  PopupContentText(v-if="popupContentText" @closePopup="closeContentText" :text="text")
  //- .footer-right
  //-   .footer-option
  //-     .icon-unfold.footer-caretOption
  //-     span.color--greyCharcoal30.text--18 中文(繁體)
  //-     ul.footer-languageList.display-none
  //-       li.footer-languageItem item 1
  //-       li.footer-languageItem item 2
</template>


<script>
import PopupContentContactForm from '@/components/popup/popup_content_contact_form.vue'
import PopupContentText from '@/components/popup/popup_content_text.vue'
import { login } from '@/plugins/login.js'
export default {
  props: {
    copyright: String,
    elements: Array
  },
  components: {
    PopupContentContactForm,
    PopupContentText
  },
  data() {
    return {
      text: [],
      popupContactForm: false,
      popupContentText: false,
      identity: localStorage.getItem(this.$store.state.storageKeys.identity)
    }
  },
  methods: {
    togglePopupContactForm() {
      if (!localStorage.getItem(this.$store.state.storageKeys.token))
        login(this.$store.state)
      else this.popupContactForm = !this.popupContactForm
    },
    isSuccess() {
      this.text=['表單已送出，我們會盡快與您聯繫，感謝您的來信。']
      this.popupContentText = true
    },
    isError() {
      this.text=['發生錯誤，請稍後再試']
      this.popupContentText = true
    },
    closeContactForm() {
      this.popupContactForm = !this.popupContactForm
    },
    closeContentText() {
      this.popupContentText = false
    }
  }
}
</script>
